import { render, staticRenderFns } from "./FactcheckField.vue?vue&type=template&id=0529cb18"
import script from "./FactcheckField.vue?vue&type=script&lang=ts"
export * from "./FactcheckField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports